import * as React from "react"
import styled from "styled-components"
import { MediaQuery } from "../../utils/design-helpers"
import IconButton from "../atoms/buttons/IconButton"
import { CameraIcon } from "../atoms/icons/CameraIcon"
import { DeleteIcon } from "../atoms/icons/DeleteIcon"

import { theme } from "../theme"
import Body from "../atoms/typography/Body"

interface ProfileImageActionableProps {
  profilePic: string
  onClickCamera: (newProfilePic: string, file: File) => void
  onClickDelete: () => void
  isEditing: boolean
}

const ProfileContainer = styled.div`
  position: relative;
  margin: ${(props) => props.theme.spacings.extreme};
  width: 255px;
`

const Image = styled.img`
  width: 255px;
  height: 255px;
  border-radius: 50%;
  object-fit: cover;
`

const CameraContainer = styled.div`
  position: absolute;
  top: -20px;
  right: 25px;

  ${MediaQuery.XS} {
    top: 205px;
    right: 66px;
  }
`

const DeleteContainer = styled.div`
  position: absolute;
  top: 50px;
  right: -25px;

  ${MediaQuery.XS} {
    top: 205px;
    right: 0px;
  }
`

const VisuallyHiddenInput = styled.input`
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const IconContainer = styled.div`
  cursor: pointer;
  border: ${(props) => `${props.theme.borders.smallWidth} solid ${props.theme.colors.greyDark}`};
  border-radius: ${(props) => props.theme.borders.buttonRadius};
  background-color: ${(props) => props.theme.colors.white};
  display: flex;
  align-items: center;
  width: 50px;
  height: 50px;
  justify-content: center;
  padding: ${(props) => props.theme.spacings.medium};

  :hover {
    background-color: ${(props) => props.theme.colors.greyLight};
  }
`

const ProfileImageActionable: React.FunctionComponent<ProfileImageActionableProps> = ({
  profilePic,
  onClickDelete,
  isEditing,
  onClickCamera,
}) => {
  const onDeleteProfileImage = () => {
    onClickDelete()
  }

  const onFileUpload = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const file = e.target.files?.[0]!
    onClickCamera(window.URL.createObjectURL(file), file)
  }

  return (
    <ProfileContainer>
      <Image src={profilePic} alt="profile image" />
      <VisuallyHiddenInput
        id="fileUpload"
        type="file"
        name="fileUpload"
        accept=".jpg, .jpeg, .png"
        onChange={onFileUpload}
      />

      {isEditing && (
        <label htmlFor="fileUpload">
          <CameraContainer id="add-user-image">
            <IconContainer>
              <CameraIcon />
            </IconContainer>
          </CameraContainer>
        </label>
      )}

      {isEditing && (
        <DeleteContainer id="remove-user-image">
          <IconButton icon={<DeleteIcon />} onClick={onDeleteProfileImage} />
        </DeleteContainer>
      )}

      {isEditing && (
        <Body color={theme.colors.greyDisabled}>
          Allowed file extensions are .jpg, .jpeg and .png. Max file size 500kb
        </Body>
      )}
    </ProfileContainer>
  )
}

export default ProfileImageActionable
